import { render, staticRenderFns } from "./achievementawardbaseConfig.vue?vue&type=template&id=17c8d47a&scoped=true&"
import script from "./achievementawardbaseConfig.vue?vue&type=script&lang=ts&"
export * from "./achievementawardbaseConfig.vue?vue&type=script&lang=ts&"
import style0 from "./achievementawardbaseConfig.vue?vue&type=style&index=0&id=17c8d47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8d47a",
  null
  
)

export default component.exports